import {
    CheckListTypes,
} from '../ActionTypes/CheckListTypes';

class CheckListActions {

    static getCheckList = payload => {
        return {
            type: CheckListTypes.GET_CHECKLIST,
            payload: payload,
        };
    };

    static clearCheckList = () => {
        return {
            type: CheckListTypes.CLEAR_CHECKLIST,
        };
    };
    static getCheckReportList = payload => {
        return {
            type: CheckListTypes.GET_CHECKLIST_REPORT,
            payload: payload,
        };
    };

    static clearCheckReportList = () => {
        return {
            type: CheckListTypes.CLEAR_CHECKLIST_REPORT,
        };
    };
}

export default CheckListActions;
